import { p as presets } from "../presets-dce40c5a.mjs";
const getColorDefaultConfig = () => ({
  get variables() {
    return this.presets[this.currentPresetName];
  },
  set variables(value) {
    this.presets[this.currentPresetName] = value;
  },
  threshold: 150,
  presets: {
    light: presets.light,
    dark: presets.dark
  },
  currentPresetName: "light"
});
export {
  getColorDefaultConfig as g
};
//# sourceMappingURL=default-6d2d858b.mjs.map
